import { IconBuildingBank } from "@tabler/icons-react";
import { fundIconMap, iconSectorMap } from "constants";

const getFundTitle = (name) => {
    const match = name.match(/\((.*?)\)/);
    if (match) return match[1];

    const words = name.trim().split(/\s+/);
    if (words.length === 1) return name;

    return words.map(w => w[0].toUpperCase()).join('');
};

const normalizeId = (str) =>
    str.toLowerCase().replace(/[^a-z0-9]/g, '');

const kebab = (str) =>
    str
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '-');

export const sectorFundsMenu = (data = [],url='') => data.map((fund) => {
    const grouped = {};

    fund.sectors.forEach((sector) => {
        const sectorName = sector.sector_name || sector.name || '';

        if (!sectorName) return; // ✅ prevent crash

        const parts = sectorName.split(/\s*-\s*/);
        const main = parts[0].trim();
        const sub = parts[1]?.trim();

        if (!grouped[main]) {
            grouped[main] = {
                id: normalizeId(main),
                title: main,
                type: 'collapse',
                icon: iconSectorMap[main] || null,
                children: []
            };
        }

        if (sub) {
            grouped[main].children.push({
                id: normalizeId(sub),
                title: sub,
                type: 'item',
                url: `/${url}/projects/${sector.id}/${kebab(sub)}`,
                target: false
            });
        } else {
            grouped[main] = {
                id: normalizeId(main),
                title: main,
                type: 'item',
                url: `/${url}/projects/${sector.id}/${kebab(main)}`,
                target: false
            };
        }
    });

    return {
        id: normalizeId(fund.fund_name),
        title: getFundTitle(fund.fund_name),
        caption: fund.fund_name.split('(')[0].trim(),
        icon: fundIconMap[fund.fund_name] || IconBuildingBank,
        type: 'group',
        children: Object.values(grouped)
    };
});
